import type {ManifestationDesignator} from 'types';
import {useManifestationIdByDesignators} from 'services/metadata';

export const useManifestationId = (
  designator: ManifestationDesignator | undefined,
): string | undefined => {
  const id = useManifestationIdByDesignators(designator);

  return id;
};
